import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PricingAuthInterceptor } from './pricing-auth-interceptor';
import { CacheInterceptor } from './cache-interceptor';
import { ApiLoaderInterceptor } from './api-loader-interceptor.service';
import { MonitoringToolInterceptor } from './monitoring-tool-interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: PricingAuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ApiLoaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: MonitoringToolInterceptor, multi: true }
];
